var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#FFE4D2",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12H13.5C12.7 12 12 12.7 12 13.5C12 14.3 12.7 15 13.5 15H22V12Z",
    fill: "#FF5C01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 17H12V26C12 27.1 12.9 28 14 28H27C27.6 28 28 27.6 28 27V18C28 17.4 27.6 17 27 17ZM24.5 24C23.7 24 23 23.3 23 22.5C23 21.7 23.7 21 24.5 21C25.3 21 26 21.7 26 22.5C26 23.3 25.3 24 24.5 24Z",
    fill: "#FF5C01"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#FF5C01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationWallet);
export default __webpack_public_path__ + "static/media/icon_notification_wallet.64122ee30e06a7c735357e01df888074.svg";
export { ForwardRef as ReactComponent };